export const GROW_IMG = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Grow_img.png';
export const RUPEE_IMG = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/rupee_img.png';
export const INSTANT_IMG = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/instant_img.png';
export const RIGHT_ICON_IMG = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Right_icon_img.png';
export const customerHeading = [
    {
        "fullName": "NAME",
        "phoneNumber": "PHONE",
        "totalCreditLimit": 'TOTAL CREDIT LIMIT',
        "availableCreditLimit": 'AVAILABLE CREDIT LIMIT',
        "principalOutstanding": 'OUTSTANDING AMOUNT',
        "action": 'ACTION',
    },
];
export const interestHeading = [
    {
        "fullName": "NAME",
        "phoneNumber": "PHONE",
        "interestRate": 'ROI',
        "interestDue": 'INTEREST DUE',
        "chargedDue": "CHARGES DUE",
        "totalDue": "TOTAL DUE",
        "mandateStatus": "MANDATE STATUS",
        "status": "STATUS",
        "action": 'ACTION',
    },
];
export const shortfallHeading = [
    {
        "fullName": "NAME",
        "phoneNumber": "PHONE",
        "availableCreditLimit": 'REVISED CREDIT LIMIT',
        "principalOutstanding": "PRINCIPAL OUTSTANDING",
        "shortfallAmount": "SHORTFLL AMOUNT",
        "aging": "MEET SHORTFALL WITHIN (DAYS)",
        "action": 'ACTION',
    },
];
export const renewalHeading = [
    {
        "fullName": "NAME",
        "phoneNumber": "PHONE NUMBER",
        "totalCreditLimit": 'TOTAL CREDIT LIMIT',
        "availableCreditLimit": "AVAILABLE CREDIT LIMIT",
        "totalOutstanding": "TOTAL OUTSTANDING",
        "renewalDueDate": "RENEW BEFORE",
        "clearDueBy": "CLEAR DUE BY",
        "status": "STATUS",
        "action": 'ACTION',
    },
];
